import type { ReactNode } from "react";
import "./layout.css";

export interface BoardColumnProps {
  title: string;
  count?: number;
  totalValue?: string;
  children: ReactNode;
  className?: string;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnter?: (e: React.DragEvent) => void;
  onDragLeave?: (e: React.DragEvent) => void;
}

/** A pipeline-stage column for the kanban board surface. */
export function BoardColumn({ title, count, totalValue, children, className, onDrop, onDragEnter, onDragLeave }: BoardColumnProps) {
  const hasMeta = Boolean(totalValue) || typeof count === "number";
  return (
    <div
      className={["ui-board-column", className].filter(Boolean).join(" ")}
      onDragOver={(e) => onDrop && e.preventDefault()}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <div className="ui-board-column__header">
        <h2 className="ui-board-column__title">{title}</h2>
        {hasMeta && (
          <p className="ui-board-column__meta">
            {totalValue ? <span className="ui-board-column__value">{totalValue}</span> : null}
            {typeof count === "number" ? (
              <span className="ui-board-column__count">({count})</span>
            ) : null}
          </p>
        )}
      </div>
      <div className="ui-board-column__body">
        {children}
      </div>
    </div>
  );
}
